import styled from 'styled-components';
import { fonts, colors } from '@/theme';

export const P = styled.p`
    ${fonts.getRegularText()};
    color: ${({ error }) => (error ? colors.messages.error : colors.messages.success)};
    margin: ${({ noMargin }) => (noMargin ? 0 : '')};
`;
